export default "__VITE_ASSET__Bgw8Jb3i__"